// extracted by mini-css-extract-plugin
module.exports = {"link":"Conditions_link__49SM4","wrapper":"Conditions_wrapper__PeawQ","text":"Conditions_text__WkmmI"};